import api from '../../services/api';
import type { Workflow, Execution, Template } from './automationTypes';

// Uses the shared `api` instance from services/api.ts which has the auth interceptor
export const automationAPI = {
  getWorkflows: () => api.get<{ workflows: Workflow[]; total: number }>('/automations/workflows'),
  createWorkflow: (data: Omit<Workflow, 'id' | 'createdAt' | 'updatedAt' | 'stats'>) =>
    api.post<Workflow>('/automations/workflows', data),
  updateWorkflow: (id: string, data: Partial<Workflow>) =>
    api.put<Workflow>(`/automations/workflows/${id}`, data),
  deleteWorkflow: (id: string) => api.delete(`/automations/workflows/${id}`),
  activateWorkflow: (id: string) => api.post(`/automations/workflows/${id}/activate`),
  deactivateWorkflow: (id: string) => api.post(`/automations/workflows/${id}/deactivate`),
  testWorkflow: (id: string) => api.post(`/automations/workflows/${id}/test`),
  getExecutions: (workflowId: string) =>
    api.get<{ executions: Execution[]; total: number }>(`/automations/workflows/${workflowId}/executions`),
  getTemplates: () => api.get<{ templates: Template[]; total: number }>('/automations/templates'),
  installTemplate: (templateId: string, overrides?: { name?: string; description?: string }) =>
    api.post(`/automations/templates/${templateId}/install`, overrides || {}),
};
